import React, {Component} from 'react';
import ActionLink from "../../../../controls/ActionLink";
import AdvertContactsModal from "../modals/AdvertContactsModal";
import AdvertDetailsModal from "../modals/AdvertDetailsModal";
import {UserContext} from "../../../../auth/Auth";
import LoginModal from "../../../../modals/LoginModal";
import PermissionsRequired from "../../../../utils/components/PermissionsRequired";
import BackEnd from "../../../../backend/BackEnd";
import Moment from "react-moment";
import {registerMetricaEvent} from "../../../../utils/metrica";

class AdvertCard extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showContactsModal: false,
        showDetailsModal: false,
        showRemoveMyAdConfirmModal: false,
        showLoginModal: false
    };

    render() {
        const { data } = this.props;
        const title = data.isUnsorted
            ? 'Неотсортированные паллеты'
            : [data.condition, data.gost, data.size].filter(x => x).join(' ');
        const loginModalBeforeForm = (
            <p>
                Для просмотра и создания объявлений, пожалуйста, введите свой номер мобильного{' '}
                телефона. На указанный номер будет выслана смс с 4-значным кодом для его верификации.{' '}
                Данный номер будет использоваться в дальнейшем для вашей идентификации.
            </p>
        );
        const comment = data.comment ? (<span title={data.comment}> <i class="fa fa-comment p-r-1"/></span>) : null;
        return (
            <div className="widget-products-item col-xs-12 col-sm-6 col-md-6 col-xl-3">
                <ActionLink className="widget-products-image"
                            onClick={() => {}}>
                    <div className="widget-products-image-wrapper">
                        <span className="img-helper"/>
                        {
                            (data.previewImage || data.article) &&
                            <img src={this.getImageUrl()}/>
                        }
                    </div>
                    <span className="widget-advert-number font-size-13 text-muted">
                        <strong>№ {data.advertNumber} от <Moment format="DD.MM.YYYY">{data.createdAt}</Moment></strong>
                    </span>
                    <div className="widget-address font-size-13 text-muted">
                        <i className="fa fa-map-marker"/>&nbsp;
                        {data.placeShortNameWhithRegion}
                    </div>
                    <span className="widget-products-overlay inverted">
                        <span className="widget-products-overlay-content-middle">
                            <div className="widget-products-overlay-content-inner">
                                <span className="col-xs-6 p-l-3">
                                    <button type="button"
                                            className="btn btn-lg btn-success btn-block p-x-0 b-a-0"
                                            onClick={() => this.openContactsModal()}>
                                        <i className="fa fa-phone"/> Контакты
                                    </button>
                                </span>
                                <span className="col-xs-6 p-r-3">
                                    <button type="button"
                                            className="btn btn-lg btn-block p-x-0 b-a-0"
                                            onClick={() => this.openDetailsModal()}>
                                        Детали
                                    </button>
                                </span>
                            </div>
                        </span>
                    </span>
                    <span className={`label label-ribbon right label-${data.advertTypeId === 1 ? 'success' : 'primary'} font-size-13`}>
                        <strong>{data.advertTypeId === 1 ? 'Продает' : 'Покупает'}</strong>
                    </span>
                    {
                        data.isMy &&
                        <span className="label label-success label-outline label-ribbon label-ribbon-second right">
                            Моё
                        </span>
                    }
                    <PermissionsRequired permissions={[1204]}
                                         denyContent={() =>
                                             data.isMy &&
                                             <span className="label label-success label-outline label-ribbon label-ribbon-bottom right">
                                                Просмотров: {data.viewsCount}
                                            </span>
                                         }>
                        <span className="label label-success label-outline label-ribbon label-ribbon-bottom right">
                            Просмотров: {data.viewsCount}
                        </span>
                    </PermissionsRequired>
                </ActionLink>
                <ActionLink className="widget-products-title"
                            title={title}
                            onClick={() => this.openDetailsModal()}>
                    {title}{comment}
                </ActionLink>
                <span className="widget-products-price label label-tag label-danger pull-xs-right font-size-13">
                    {data.costPerItem} р./шт.
                </span>
                <div className="widget-products-footer text-muted">
                    <i className="fa fa-star-o p-r-1"/> {data.quality || 'н/д'}
                    <br/>
                    <i className="fa fa-bars p-r-1"/> {data.deckType || 'н/д'}
                    <br/>
                    <i className="fa fa-tint p-r-1"/> {data.humidity || 'н/д'}
                </div>
                <AdvertContactsModal data={data}
                                     show={this.state.showContactsModal}
                                     onHide={() => this.handleContactsModalClose()}/>
                <AdvertDetailsModal data={data}
                                    show={this.state.showDetailsModal}
                                    onRemove={() => this.props.onRemove()}
                                    onHide={() => this.handleDetailsModalClose()}/>
                <LoginModal beforeForm={loginModalBeforeForm}
                            show={this.state.showLoginModal}
                            onLogin={() => window.location.reload()}
                            onHide={() => this.setState({showLoginModal: false})}/>
            </div>
        );
    }

    getImageUrl() {
        const {data} = this.props;

        if (data.previewImage) {
            return new BackEnd.ViewImage.View().createUrl({
                imageId: data.previewImage
            });
        }
        else {
            return data.article !== 'U3' && data.article !== 'U4'
                ? `/assets/img/pallets/${data.article}.png`
                : '';
        }
    }

    openContactsModal() {
        const userContext = UserContext.get();
        registerMetricaEvent('try_get_contacts');
        if (userContext) {
            this.setState({showContactsModal: true});
        }
        else {
            this.setState({showLoginModal: true});
        }
    }

    openDetailsModal() {
        this.setState({
            showContactsModal: false,
            showDetailsModal: true
        })
    }

    handleContactsModalClose() {
        this.setState({
            showContactsModal: false
        });
    }

    handleDetailsModalClose() {
        this.setState({
            showDetailsModal: false
        });
    }
}

export default AdvertCard;


// WEBPACK FOOTER //
// ./src/pages/Adverts/AdvertList/components/AdvertCard.js